(function () {
    'use strict';

    angular
        .module('app')
        .controller('SchoolsListController', SchoolsListController);

    SchoolsListController.$inject = ['API', 'alert', 'debug', '$stateParams', 'ListViewSearchExtension', 'i18n',];

    function SchoolsListController(API, alert, debug, $stateParams, ListViewSearchExtension, i18n) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = 'latestFirst';
        vm.loadingState = {
            schoolIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;
        vm.schools = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadResources(true);
        }

        function openRemoveModal(school) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.School.recycle({ id: school.id }).$promise;

                removePromise.then(function() {
                    var index = vm.schools.findIndex(function(item) {
                        return item.id === school.id;
                    });
                    vm.schools.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('SCHOOL_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };
            if (vm.listObject.filter) {
                switch (vm.listObject.filter) {
                    case 'latestFirst':
                        searchObject.sort = '-created';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created';
                        break;
                    case 'alphabetAscending':
                        searchObject.sort = '-name';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'name';
                        break;
                    case 'verified':
                        searchObject.status = 'verified';
                        break;
                    case 'unverified':
                        searchObject.status = 'unverified';
                        break;

                    default:
                        break;
                }
            }
            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.School.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.School.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.schoolIsLoading = true;
                promise.then(function (response) {
                    vm.schools = response.items;
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.schoolIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }
    }
})();